import { parseId } from './parseId.js';
export function parseKey(key, getEntity) {
    const dotIndex = key.indexOf('.');
    if (dotIndex === -1) {
        return undefined;
    }
    const type = key.slice(0, dotIndex);
    const id = key.slice(dotIndex + 1);
    if (getEntity) {
        const entity = getEntity(type);
        if (!entity) {
            return undefined;
        }
        return {
            type: entity.type,
            id: parseId(entity, id),
        };
    }
    return { type, id };
}
//# sourceMappingURL=parseKey.js.map